import React from "react";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/data";
import { Reveal, Overline } from "./Reveal";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="relative py-12 md:py-16 border-y border-line">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>Trusted by leaders</Overline>
          <h2 className="mt-5 font-heading text-4xl md:text-5xl font-bold tracking-tight max-w-2xl leading-tight">
            What our clients <span className="text-gradient">say</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <div className="h-full rounded-2xl glass p-6 hover:border-brand/40 transition-colors duration-500 flex flex-col">
                <Quote size={26} className="text-brand" />
                <p className="mt-4 text-lg leading-relaxed flex-1">{`"${t.quote}"`}</p>
                <div className="mt-6 pt-5 border-t border-line">
                  <p className="font-heading font-semibold">{t.name}</p>
                  <p className="text-sm text-textsub">{t.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
